import { generateClient } from "aws-amplify/api";
import { billingAppSyncConfig } from "../config/billing-api.ts";

// Create dedicated client for billing API
export const billingApiClient = generateClient({
    endpoint: billingAppSyncConfig.endpoint,
    region: billingAppSyncConfig.region,
    authMode: 'userPool'
});